/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CoursefinancialCoursefinancialidLangs201,
  PostApiV1CoursefinancialCoursefinancialidLangs400,
  PostApiV1CoursefinancialCoursefinancialidLangs401,
  PostApiV1CoursefinancialCoursefinancialidLangs404,
  PostApiV1CoursefinancialCoursefinancialidLangs500,
  PostApiV1CoursefinancialCoursefinancialidLangsMutationRequest,
  PostApiV1CoursefinancialCoursefinancialidLangsMutationResponse,
  PostApiV1CoursefinancialCoursefinancialidLangsPathParams,
} from "../../types/courseFinancialLangsController/PostApiV1CoursefinancialCoursefinancialidLangs.ts";
import { courseFinancialLangEditorViewModelSchema } from "../courseFinancialLangEditorViewModelSchema.ts";
import { courseFinancialLangViewModelSchema } from "../courseFinancialLangViewModelSchema.ts";

export const postApiV1CoursefinancialCoursefinancialidLangsPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidLangsPathParams>;

/**
 * @description (Created) Objeto criado com sucesso.
 */
export const postApiV1CoursefinancialCoursefinancialidLangs201Schema = z.lazy(
  () => courseFinancialLangViewModelSchema,
) as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidLangs201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CoursefinancialCoursefinancialidLangs400Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CoursefinancialCoursefinancialidLangs401Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1CoursefinancialCoursefinancialidLangs404Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CoursefinancialCoursefinancialidLangs500Schema =
  z.any() as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidLangs500>;

export const postApiV1CoursefinancialCoursefinancialidLangsMutationRequestSchema =
  z.lazy(
    () => courseFinancialLangEditorViewModelSchema,
  ) as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidLangsMutationRequest>;

export const postApiV1CoursefinancialCoursefinancialidLangsMutationResponseSchema =
  z.lazy(
    () => postApiV1CoursefinancialCoursefinancialidLangs201Schema,
  ) as unknown as ToZod<PostApiV1CoursefinancialCoursefinancialidLangsMutationResponse>;
